export const DescriptionSchema = {
    descriptionAdmin: [
        { rule: "required", message: "Description required" },
    ]
}